import { Text } from '@chakra-ui/react'

import OnboardingInputGrayCheckboxMulti from '@/components/Onboarding/OnboardingInputGrayCheckboxMulti'
import BioExamples from '@/components/OnboardingV2/BioExamples'
import type { FormInputType } from '@/components/UI/Form/types'

export default function getYourProfileFormInputs({
  defaultBio,
}: {
  defaultBio?: string | null
}): FormInputType[] {
  return [
    {
      label:
        'Write a public bio! Introduce yourself to the community and share why you’re joining Schoolhouse.',
      sublabel: (
        <Text fontWeight={400} variant="supporting" color="fg.muted">
          This bio will appear on your public profile and will be reviewed by our content review
          team. Please do NOT include any personally-identifying information such as your school’s
          name, your last name, email, social media handles, and more.
        </Text>
      ),
      type: 'textarea',
      name: 'bio',
      required: true,
      placeholder: `e.g. I'm a high school student from Arkansas and I'm here to study for the SAT. In my free time I like hiking, roller skating, and watching Netflix.`,
      description: <BioExamples />,
      initialValue: defaultBio ?? null,
      minLength: 20,
      size: 6,
    },
    {
      name: 'no-pii-confirmation',
      type: 'multi-checkbox',
      label: 'Confirm that you did not include any personally-identifying information',
      required: true,
      Component: OnboardingInputGrayCheckboxMulti,
      options: [
        {
          label: (
            <Text>
              I{' '}
              <Text as="span" fontWeight="semibold">
                did not
              </Text>{' '}
              include any personally-identifying information such as my school&apos;s name, my last
              name, email or social media handles.
            </Text>
          ),
          value: 'confirmed',
        },
      ],
      size: 6,
    },
  ]
}
